// Every tuning knob for the room lives here. Units are three.js world units
// (roughly "metres"): the camera sits ~9 units from the middle of the room.
export const CONFIG = {
  camera: {
    position: [0, 0.5, 9],
    lookAt: [0, 0.2, -2],
    fov: 38,
    parallax: 0.5, // how far the camera drifts toward the pointer
  },

  room: {
    wallZ: -9.5, // back wall that catches the big shadows
    background: '#dfe1e3',
    wall: '#e9e7e2',
    fogNear: 12,
    fogFar: 34,
  },

  hanging: {
    pivotY: 8.6, // where the threads are tied, far above the top of the frame
  },

  breeze: {
    swing: 0.032, // radians of pendulum swing (small angle × long thread = visible sway)
    twist: 0.1, // radians the paper slowly rotates about its thread
    speed: 1,
  },

  hover: {
    focusZ: 1.7, // depth the hovered cutout comes forward to
    pushBack: 1.5, // how far every other cutout retreats
    damping: 4.2, // higher = snappier
    calm: 0.2, // the held cutout sways at this fraction of normal
  },

  open: {
    ms: 650, // how long the "step into the paper" transition runs before onSelect fires
    distance: 3.4, // how close to the camera the cutout flies when clicked
  },

  flipbook: {
    fps: 6, // hand-drawn animations feel right at 4–8 fps
  },

  candle: {
    z: 4.1, // depth of the flame plane (in front of every cutout)
    color: '#ffa94d',
    intensity: 48, // candela. Falls off with the inverse square of distance
    idleIntensity: 14, // when the pointer is not in the room
    idleNdc: [0.12, 0.12], // where the flame rests when the pointer is away
    follow: 16, // how tightly the light tracks the pointer
    shadowMapSize: 1024,
  },

  paper: {
    bump: 0.25, // fibre texture strength: raking candle light reveals it
    edge: '#efe6d2',
  },

  loader: {
    minMs: 15000, // keep the loader visible for roughly 15s so the room feels like it is loading intentionally
  },
}
